module.exports = __webpack_public_path__ + "c6d0248363ca7efd551fd43293978c1b.MP3";